import { ProductTuple } from '@/stores/search/util';
import { Config } from '@/util/Config';
import { ProductImageDto } from '@/api';
import { ShopContext } from '@/util/ShopContext';

export const Urls = {
  toLinkFriendlyString(str: string): string {
    return str
      .replace(/ä/g, 'ae')
      .replace(/ü/g, 'ue')
      .replace(/ö/g, 'oe')
      .replace(/ß/g, 'ss')
      .replace(/\W+/g, '-');
  },
  thumbnailFor(tuple: ProductTuple): string {
    const {unit, product} = tuple;
    if (product.images && product.images.length > 0) {
      const image = product.images.find((img) => img.unitAbbreviation === unit.abbreviation);
      if (!image) {
        return `${Config.IMAGE_BASE}/${product.images[0].thumbnailPath}`;
      }
      return `${Config.IMAGE_BASE}/${image.thumbnailPath}`;
    } else {
      return '';
    }
  },
  mediumPathFor(image: ProductImageDto): string {
    return `${Config.IMAGE_BASE}/${image.mediumPath}`;
  },
  bigPathFor(image: ProductImageDto): string {
    return `${Config.IMAGE_BASE}/${image.bigPath}`;
  },
  logoPath(): string {
    return `${Config.HUB_API_BASE}/images/${ShopContext.tenantCode}/${ShopContext.shopCode}-logo.png`;
  },
};
